<template>
  <div class="account-selector">
    <el-form v-loading="formLoading" :model="userForm" :rules="rules" ref="userForm">
      <el-form-item prop="username">
        <el-select v-model="userForm.user_id" placeholder="Select an account" @change="selectAccount" class="w-100">
          <el-option
            v-for="account in goodAccounts"
            :key="allAccounts.indexOf(account)"
            :label="`@${account.profile.username}`"
            :value="account.user_id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AccountSelector',
  data () {
    return {
      formLoading: false,
      userForm: {},
      rules: {
        user_id: [
          { required: true, message: 'Please select an account.', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'gold',
      'allAccounts',
      'currentPage'
    ]),
    goodAccounts () {
      return this.allAccounts.filter(a => {
        if (a.needsLogin || a.likeBlocked) {
          return false;
        } else {
          return true;
        }
      });
    }
  },
  methods: {
    selectAccount () {
      this.$emit('selectedAccount', this.userForm.user_id);
    }
  }
}
</script>

<style lang="scss">
.account-selector {
  margin-top: 40px;
  text-align: center;
}
</style>
